import React, { useEffect, useMemo, useState } from 'react';
import { Typography } from '@mui/material';
import { StyledDiv, StyledIndexContainerDiv, StyledLeadContainer } from '../../Components/Styled/index';
import history from '../../Utility/history';
import { privateRoutesPath } from '../../Routes';
import { GridRowModes } from '@mui/x-data-grid';
import moment from 'moment';
import {Button, Stack} from '@mui/material';
import { useSnackbar } from 'notistack';
import DataGridTable from '../../Components/DataGrid';
import SearchSalesOrder from './SearchSalesOrder';
import './salesOrder.css';
import OrderSlipDialog from '../../Components/FullScreenDialog';
import { createRequestData, updateRequestData } from '../../Utility/apiHelper';
import { useDispatch, useSelector } from 'react-redux';
import { ACTIVE_STATUS, ARRAY_SERIALIZER, handleValidateCodevalue, idWidth, nameWidth, ownerWidth, SALES_ORDER_STATUS, salesOrderIdWidth, searchEntity, sellingPriceWidth, statusWidth, whocolumnWidth } from '../../Utility/constant';
import LeadDialog from '../../Components/LeadDialog';
import BiztantuSearch from '../../Components/BiztantuSearch';
import { requestGetAllSalesOrders } from '../../Store/SalesOrder/action';
import { requestGetAllCustomers } from '../../Store/Customer/action';
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import BiztantuLoader from '../../Components/Loader';
import { requestHideLoader, requestShowLoader } from '../../Store/Global/action';
import { useSearchExecutor } from '../../Components/CustomHooks/useSearchExecutor';
import { resetSearch, setSearch } from '../../Store/SearchReducer/action';
import { resetState } from '../../Utility/resetSearchFunction';
import { buildEntitySearchValues } from '../../Utility/buildEntitySearchValues ';
import { useEntitySearch } from '../../Utility/hooks/useEntitySearch';
import useNavigation from '../../Utility/hooks/useNavigation';

const OrderPage = (props) => {
  const [dataGridData, setDatagridData] = useState([]);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [open, setopen] = useState(false);
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
  const [isOpenDialog , setIsOpenDialog] = useState(false);
  const [ownerlistdropdown, setownerlistdropdown] = useState([]);
  const ownerlist = useSelector(state => state?.owner?.ownerlist);
  const [selectedowner, setSelectedOwner] = useState("");
  const customerdropdown = useSelector(state => state?.customer?.customer);
      const salesOrderData = useSelector(state => state?.salesOrder?.salesOrder)
  const dispatch = useDispatch();
  const today = new Date();
      const daysAgo = new Date();
      const currentUser = useSelector(state => state?.owner?.currentuser);
      daysAgo.setDate(today.getDate() - 90);
      const orderSearch = useSelector((state) => state?.search?.salesOrder) || {};
      const currentOwnerId = useSelector(state => state?.owner?.currentuser?.userId);
      const myTeam = useSelector(state => state?.owner?.Team);
      const SOStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == SALES_ORDER_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
      const currentOwner = ((specificRolePermission?.isAllOrderManage ? ownerlist : specificRolePermission?.isOrderTeamManage ? myTeam : ownerlist) || []).find(item=> item?.id === currentOwnerId)
      
      const { navigateTo } = useNavigation();
      useEffect(()=>{
      setSelectedOwner(currentOwner)
        },[currentOwner])

      useEffect(() => {
        dispatch(requestGetAllCustomers());
      }, []);
      

    const isReady =
    (myTeam?.length > 0 ||
    ownerlist?.length > 0) &&
    currentUser?.userId &&
    internationalise &&
    Object.keys(internationalise).length > 0;

        const preserveSearch = useSelector(
          state => state?.search?.preserveSearch?.[searchEntity?.salesOrder]
        );
    
            const { updatedSearch, newList } = useMemo(() => 
                    buildEntitySearchValues({
                        entity: searchEntity?.salesOrder,
                        currentUser,
                        specificRolePermission,
                        ownerlist,
                        myTeam,
                        daysAgo,
                        today,
                        isAllManage: specificRolePermission?.isAllOrderManage,
                        isTeamManage: specificRolePermission?.isOrderTeamManage,
                        internationalise,
                        handleValidateCodevalue,
                    }), [currentUser, specificRolePermission, ownerlist, myTeam, internationalise]);
            
            useEffect(() => {
            dispatch(setSearch(searchEntity?.salesOrder, updatedSearch));
        }, [dispatch,updatedSearch]);
        
                useEffect(() => {
            setownerlistdropdown(newList);
            }, [newList]);
        
            useEntitySearch({
                entity: searchEntity?.salesOrder,
                preserveSearch,
                searchState: orderSearch,
                isReady,
                getInitialState: () => updatedSearch,
                fetchAction: (search) =>
                requestGetAllSalesOrders({
                    params: buildSearchParams(search),
                    paramsSerializer: ARRAY_SERIALIZER,
                }),
                });

const handleChangeSearchField = (event) => {
            dispatch(setSearch(searchEntity?.salesOrder, {
                ...orderSearch,
                [event.target.name]: event.target.value,
            }));
        };

  const handleReassignOwner = (event , Owner)=>{
    setSelectedOwner(Owner);
  }

   const handleSelectOwner = (event, Owner,entity) => {
    if(entity==="Customer"){
      dispatch(setSearch(searchEntity?.salesOrder, {
                ...orderSearch,
              selectedCustomer : Owner,
              customerId : Owner?.id
        }));
    }
    else{
      if ((!Owner || Owner.length === 0) && !specificRolePermission?.isAllOrderManage) {
        enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_SELECT_OWNER_WARNING"), { variant: "warning" });
        return;
      }
        dispatch(setSearch(searchEntity?.salesOrder, {
          ...orderSearch,
        selectedOwner: Owner,
        ownerName: Owner?.name
        }));
  }
}

   
    useEffect(() => {
      const updatedLeadTable = (salesOrderData || [])?.map((item,index)=>{
        return {
          ...item,
        }
      })
      setDatagridData(updatedLeadTable);
    }, [salesOrderData]);

    // when you handleReset button
    const handleResetSearch = () => {
      dispatch(
        resetSearch(searchEntity?.salesOrder,resetState(orderSearch, {
            selectedOwner: orderSearch?.selectedOwner,
            ownerId : orderSearch?.ownerId,
            ownerName: orderSearch?.ownerName
        })
      )
    );
    }
  const handleSave= async()=>{
    const rowsData = dataGridData.filter(function(item){
        return selectionModel.indexOf(item.id) !== -1;
      });
  
  
      const reqPayload = rowsData.filter((item, index) => item?.owner != selectedowner?.id);

     const payload = reqPayload.map(item => {
        return {
          id: item?.id,
          ownerId: selectedowner?.id
        }
      })

        try {
        const response = await updateRequestData(
            payload,
            "sales-orders/assign"
        );

        if (response?.status === "error") {
            enqueueSnackbar(
                handleValidateCodevalue(
                    internationalise,
                    response?.propererror?.data?.summary || "COMMON_PLEASE_TRY_AGAIN"
                ),
                { variant: "error" }
            );
            return;
        }

        enqueueSnackbar(
            `${response?.data?.success} ${handleValidateCodevalue(
                internationalise,
                "SO_ASSIGNED_TO"
            )} ${selectedowner?.firstName} ${selectedowner?.lastName}`,
            { variant: "success" }
        );

        handleCloseDialog();
        handleSearchOrder();
    } catch (error) {
        enqueueSnackbar(
            handleValidateCodevalue(
                internationalise,
                error?.propererror?.data?.summary ||
                    "COMMON_PLEASE_TRY_AGAIN"
            ),
            { variant: "error" }
        );
    }
  }

  const columns = [  
      { 
      field: 'orderId', 
      headerName: handleValidateCodevalue(internationalise,'SO_SEARCH_SO_ID'),
      flex: 1,
      minWidth : salesOrderIdWidth,
      editable: true ,
      renderCell : ({id})=>(
          <span
      onClick={handleViewOrderSlip(id)}
      className="sales-order-id-link"
        >
          {id}
        </span>
      )
      },
      {
      field: 'customerId',
      headerName: handleValidateCodevalue(internationalise,'SO_SEARCH_CUSTOMER'),
      flex: 1,
      minWidth : nameWidth,
      editable: false,
      valueGetter: ({ value }) => {
      if (!value) return '';
      const customer = customerdropdown?.find((item) => item?.id === value);
      return customer ? `${customer?.firstName || ''} ${customer?.lastName || ''}`.trim() : '';
       } 
      },
    {
      field: 'leadId',
      headerName: handleValidateCodevalue(internationalise,'SO_SEARCH_LEAD_ID'),
      flex: 1,
      minWidth: idWidth,
      editable: false,
    },
    {
      field: 'ownerId',
      headerName: handleValidateCodevalue(internationalise,'SO_SEARCH_OWNER'),
      flex: 1,
      minWidth: ownerWidth,
      editable: false,
      valueGetter: ({ value }) => {
      const owner = ownerlistdropdown.find(c => c.id === value);
      return owner ? owner.name : '';
      },  
      
    },
    { 
      field: 'totalOrderPrice', 
      headerName: handleValidateCodevalue(internationalise,'SO_SEARCH_TOTAL_PRICE'),
      flex: 1,
      minWidth : sellingPriceWidth,
      editable: false,
    },
    {
      field: 'status',
      headerName: handleValidateCodevalue(internationalise,'SO_STATUS'),
      flex: 1,
      minWidth : statusWidth,
      editable: false,
      valueGetter : ({value}) => {
        return handleValidateCodevalue(internationalise,value)
      }
    },
    {
      field: 'createdAt',
      headerName: handleValidateCodevalue(internationalise,'COMMON_CREATED_AT'),
      type: 'date',
      flex: 1,
      minWidth : whocolumnWidth,
      editable: false,
      valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
    },
    {
      field: 'updatedAt',
      type: 'date',
      headerName: handleValidateCodevalue(internationalise,'COMMON_UPDATED_AT'),
      flex: 1,
      minWidth : whocolumnWidth,
      editable: false,
      valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
    },
  ];

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
      setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleEditLead = (id) => () => {
      history.push(`${privateRoutesPath.EDIT_CUSTOMER}/${id}`);
  };

  const handlegenerateinvoice = async(cellrecord) => {
  
        const reqObj = {
          description: cellrecord?.row?.description,
          title: cellrecord?.row?.title
        }

        const url = `${process.env.REACT_APP_NODE_BASE_URL}/genrate-invoice`;

        const responseData = await createRequestData(reqObj, url, false);

        if(responseData?.status == 200) {
            enqueueSnackbar(responseData?.data?.message, {variant: 'success'})
        }
  }


  const handleViewOrderSlip = (id) =>() => {
        navigateTo(`${privateRoutesPath.VIEW_ORDER}/${id}`,{},searchEntity?.salesOrder)
  }

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = dataGridData.find((row) => row.id === id);
    if (editedRow.isNew) {
      setDatagridData(dataGridData.filter((row) => row.id !== id));
    }
  };

  
      const { buildSearchParams, executeSearch } = useSearchExecutor({
          ownerlist,
          myTeam,
          enqueueSnackbar,
          internationalise,
          handleValidateCodevalue,
      });
  

 const handleSearchOrder = async() => {
  const params = buildSearchParams(orderSearch);
      if (!params) return;
      dispatch(requestShowLoader())
      executeSearch(requestGetAllSalesOrders, params);
      dispatch(requestHideLoader())
    };

  const handleUpdateCustomer = (rowRecord) => {
    
  }

  const handleClose = () => {
      setopen(false);
  }

  
  const handleCloseDialog = () => {
      setIsOpenDialog(false);
      setSelectionModel([]);
      if (currentOwner) {
    setSelectedOwner(currentOwner);
  }

  }
  
  const salesOrderSearchBox = {
    ...orderSearch
  }

    const handleSelectAutocomplete = (e,value,name)=>{
      dispatch(setSearch(searchEntity?.salesOrder, {
          ...orderSearch,
            [name] : value
        }));
    }
  const isLoadingProgress = useSelector(state => state?.global.isLoading); 
  return (
        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
    <StyledDiv>
      <StyledLeadContainer>
        <Typography variant='h6' className='mb-20'>
        {handleValidateCodevalue(internationalise,'SO_SEARCH_TITLE')}
        </Typography>
        <Stack spacing={2} direction="row">
        </Stack>
      </StyledLeadContainer>
      {/* <SearchSalesOrder
        customerdropdown = {customerdropdown}
        handleSearchOrder={handleSearchOrder}
      /> */}
      <StyledIndexContainerDiv>
            <StyledLeadContainer className="sales-order-search-panel">
                <Stack className='table-header-search table-header-search-common'>
                  <BiztantuSearch
                    showStatus = {false}
                    showOwner = {true}
                    entityDetails = {salesOrderSearchBox}
                    ownerlistdropdown = {ownerlistdropdown}
                    handleReset = {handleResetSearch}
                    handleSearch = {handleSearchOrder}>
                    <SearchSalesOrder
                    handleSelectStatus = {handleSelectAutocomplete}
                    customerdropdown={customerdropdown}
                    handleResetSearch = {handleResetSearch}
                    handleSelectOwner = {handleSelectOwner}
                    ownerlistdropdown = {ownerlistdropdown}
                    entityDetails = {orderSearch}
                    handleOnChange = {handleChangeSearchField}
                    />
                  </BiztantuSearch>
                </Stack>
                <Stack className='secondry-btn-container' width="60%" padding="10px" justifyContent="flex-end" spacing={2} direction="row">
                   
                {specificRolePermission?.isOrderManage &&
                   <Button className='biztantu-sec-btn' variant="outlined" onClick={() => navigateTo(`${privateRoutesPath.CREATE_ORDER}`,{},searchEntity?.salesOrder)}>{handleValidateCodevalue(internationalise,'SO_CREATE')}</Button>
                }</Stack>
                
            </StyledLeadContainer>
      <DataGridTable
        isOrderScreen = {true}
        height='calc(100vh - 218px)'
        dataGridData={dataGridData}
        setIsOpenDialog={setIsOpenDialog}
        filename="order"
        columns={columns}
        rowModesModel={rowModesModel}
        handleUpdateCustomer={handleUpdateCustomer}
        selectionModel={selectionModel}
        setSelectionModel={(data) => setSelectionModel(data)}
        
      />
    {isOpenDialog && 
    (
                        <LeadDialog
                            open = {isOpenDialog}
                            handleClose = {handleCloseDialog}
                            title= {handleValidateCodevalue(internationalise,"SO_REASSIGN_TITLE")}
                            size="sm"
                            selectedowner={selectedowner}
                            btnlabel={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                            handleSave={handleSave}
                        >
                                            <AutoCompleteComponent
                                              isOwner = {true}
                                              optionSet = {(specificRolePermission?.isAllOrderManage ? ownerlist 
                                                : specificRolePermission?.isOrderTeamManage ? myTeam 
                                               : [{
                                              firstName: `${currentUser?.firstname}`,
                                              lastName : `${currentUser?.lastname}`,
                                              id: currentUser?.userId,
                                            }]) || []}
                                              value={selectedowner|| null}
                                              name = "managerId"
                                              placeholder={handleValidateCodevalue(internationalise,"SO_REASSIGN_SELECT_OWNER")}
                                              disabled = {!(specificRolePermission?.isAllOrderManage || specificRolePermission?.isOrderTeamManage)}
                                              label={handleValidateCodevalue(internationalise,'SO_SEARCH_OWNER')}
                                              onChange={(event, Owner) => handleReassignOwner(event, Owner)}
                                              />
                            
                        </LeadDialog>
                    )
                    }

      {open &&
        <OrderSlipDialog
          open={open}
          recordData = {selectedInvoice}
          handleClose={handleClose}
        />
      }
      </StyledIndexContainerDiv>
    </StyledDiv>
    </BiztantuLoader>
  )
}

export default OrderPage;